/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import {useUserContext} from "../../../contexts/userContext";

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as LabelIcon } from '../../../resources/images/as-label.svg';

/* Styles */
import styles from "./styles";


const EditLabelModal = ({showModal, setShowModal, setShowDeleteModal, label, handleSubmit, successCallback}) => {

  const theme = useTheme();
  const classes = styles({ theme });

  const userDetails = useUserContext();

  const companyEntityId = userDetails?.userInfo?.companyInfo?.companyEntityId

  return (
    <UCModal
      className={classes.editModal}
      showModal={ showModal }
      setShowModal={ setShowModal }
      modalIcon={ <LabelIcon /> }
      modalTitle={ <FormattedMessage id="editLabel.title" /> }
      modalDescription={ <FormattedMessage id="editLabel.description"/> }
      modalContent={
        <Content
          label={ label }
          setShowModal={ setShowModal }
          handleSubmit={handleSubmit}
          successCallback={successCallback}
          setShowDeleteModal={setShowDeleteModal}
          companyEntityId={companyEntityId}
        /> }
      dataTestId="editLabelModal"
    />
  )
}

export default EditLabelModal;
